<template>
  <div class="page notify__page">
    <div class="page__hd">
      <h1 class="page__title">{{ form.title }}</h1>
      <p class="page__desc">
        <span v-format="'yyyy-MM-dd'">{{ form.upgradeTime }}</span>
      </p>
    </div>
    <html-viewer class="page__bd" v-if="form.content" :content="form.content" />
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import HtmlViewer from "@/components/HtmlViewer.vue";

export default {
  mixins: [form],
  components: {
    HtmlViewer
  },
  data() {
    return {
      baseUrl: "/api/operation/sys_upgrade",
    };
  }
};
</script>

<style scoped>
.notify__page {
  background: #fff;
}

.notify__page .page__hd {
  padding: 0 20px;
  text-align: center;
}

.notify__page .page__title {
  font-weight: normal;
}

.notify__page .page__desc {
  color: #888;
}
</style>